
import { Component } from "vue-property-decorator";
import draggable from "vuedraggable";
import AttributeMenu from "@/components/attribute/AttributeMenu.vue";
import Icon from "@/components/reusable/Icon.vue";
import Table from "@/components/reusable/table/Table.vue";
@Component({
  components: {
    draggable,
    AttributeMenu,
    Icon
  }
})
export default class AttributeTable extends Table {
  /** Tooltip for the DELETED badge: when the attribute was soft-deleted. */
  protected deletedTooltip(row: { deleted_at?: string | null }): string {
    if (!row.deleted_at) {
      return "";
    }
    return "title: Deleted on " + new Date(row.deleted_at).toLocaleString();
  }
}
